import { getBackCategory } from "@/api";

// One in-flight load per Pinia instance, shared by startup and retry controls.
// This is not a persistent category cache.
const pendingLoads = new WeakMap<object, Promise<boolean>>();

export const useBackCategoryLoader = () => {
  const catStore = useCatStore();

  const loadCategories = (): Promise<boolean> => {
    const pending = pendingLoads.get(catStore);
    if (pending) return pending;

    catStore.startCategoryLoading();
    const request = Promise.resolve()
      .then(() => getBackCategory({ level: 0, thin: true }))
      .then((response) => {
        if (
          !Array.isArray(response?.result) ||
          response.result.some((item) => !item || typeof item !== "object" || Array.isArray(item))
        ) {
          throw new Error("Invalid category response");
        }
        catStore.setBackCategories(response.result);
        return true;
      })
      .catch(() => {
        catStore.failCategoryLoading();
        return false;
      })
      .finally(() => {
        catStore.finishCategoryLoading();
        pendingLoads.delete(catStore);
      });
    pendingLoads.set(catStore, request);
    return request;
  };

  return { loadCategories };
};
